import React from "react";
import { useNavigate } from "react-router-dom";
import secondImage from "../../assets/images/icons/no_results.svg";
import { useTranslation } from "react-i18next";
import { INotification } from "../../interface/GeneralResponse";
import { NotificationItem } from "../../pages/Notifications/NotificationItem";
import { GeneralButton } from "../../components";

export interface NotificationProps {
  UnseenCount: number;
  Notifications: INotification[];
}
interface NotificationPopupProps {
  onClose: () => void;
  data?: NotificationProps;
}

const NotificationPopUp: React.FC<NotificationPopupProps> = ({
  data,
  onClose,
}) => {
  const navigate = useNavigate();
  const notificationsData = data?.Notifications;
  const { t } = useTranslation();

  return (
    <div className="z-10 w-[70vw] flex-col gap-4 !p-2 sm:w-[20rem] md:w-[26rem]">
      <div className="text-primary-text pb-4 text-base font-bold">
        {t("notifications")}
      </div>
      <div className="flex h-fit flex-col gap-8 self-stretch">
        <div className="flex h-fit max-h-[300px] flex-col gap-2 self-stretch overflow-auto">
          {(notificationsData?.length ?? 0 > 0) ? (
            notificationsData?.map((item: INotification, index: number) => {
              return (
                <NotificationItem
                  onClose={onClose}
                  item={item}
                  key={index}
                  noTrash
                />
              );
            })
          ) : (
            <div className="mt-5 flex w-full flex-col items-center justify-center gap-4">
              <img className="w-28" src={secondImage} alt="No Results" />
              <p className="text-body-text text-center">
                {t("no_notifications")}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="mt-4">
        {(notificationsData?.length ?? 0) > 0 && (
          <GeneralButton
            title={t("view_all")}
            onClick={() => {
              navigate("notifications");
              onClose();
            }}
            className="w-full"
            color="lite"
          />
        )}
      </div>
    </div>
  );
};

export default NotificationPopUp;
